import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { Theme } from '@routific/hive';

const TextInput = React.forwardRef(function TextInput(
  props: TextFieldProps & { hasError?: boolean },
  ref: React.Ref<HTMLInputElement>,
) {
  const { InputProps, required, onFocus, hasError, ...other } = props;

  return (
    <TextField
      {...other}
      data-testid={'text-input'}
      required={required}
      inputRef={ref}
      InputProps={{
        ...InputProps,
        size: 'small',
        color: hasError ? 'error' : undefined,
      }}
      onFocus={(e) => {
        if (props.onFocus) props.onFocus(e);
      }}
      onBlur={(e) => {
        if (props.onBlur) props.onBlur(e);
      }}
      sx={{
        width: '100%',
        '& .MuiInputBase-root': {
          fontFamily: 'inherit', 
        },
        '& .MuiOutlinedInput-root': {
          borderRadius: Theme.BorderRadius.mdBorderRadius,
          '&.MuiInputBase-colorError fieldset': {
            borderColor: Theme.Colors.danger5,
            borderWidth: 1,
          },
          '& fieldset': {
            borderColor: Theme.Colors.gray4,
            borderWidth: 1,
          },
          '&:hover fieldset': {
            borderColor: Theme.Colors.primary5,
            borderWidth: 1,
          },
          '&.Mui-focused fieldset, &.Mui-focused fieldset.Mui-focused': {
            borderColor: Theme.Colors.primary6,
            borderWidth: 1,
          },
          '&.Mui-focused.MuiInputBase-root': {
            backgroundColor: Theme.Colors.primary1,
          },
        },
      }}
    />
  );
});

export default TextInput;
